import { useEffect } from 'react';
import {
	useAnimatedStyle,
	useReducedMotion,
	useSharedValue,
	withDelay,
	withTiming,
	type AnimatedStyle,
} from 'react-native-reanimated';
import type { ViewStyle } from 'react-native';
import Dimens from 'src/core/utils/Dimens';
import { gridEnterDelay } from 'src/presentation/helpers/CardGrid';

// Not an `entering` layout animation: on Android a re-render mid-animation leaves that stuck at its initial offset.
export function useGridCardEntrance(index: number): AnimatedStyle<ViewStyle> {
	const reducedMotion = useReducedMotion();
	const progress = useSharedValue(reducedMotion ? 1 : 0);

	useEffect(() => {
		if (reducedMotion) {
			progress.value = 1;
			return;
		}

		progress.value = withDelay(gridEnterDelay(index), withTiming(1, { duration: Dimens.animationDuration300 }));
	}, [index, progress, reducedMotion]);

	return useAnimatedStyle(() => ({
		opacity: progress.value,
		transform: [{ translateY: Dimens.animationOffset25 * (1 - progress.value) }],
	}));
}
